import styled from 'styled-components';

export const PriceRangeContainer = styled.div`
  color: #000000;
  margin-top: 32px;
  margin-bottom: 32px;
`;

export const PriceRangeText = styled.span`
  font-weight: 500;
  font-size: 16px;
`;

export const PriceFilterContainer = styled.div`
  @media (max-width: 480px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;
